import React, { createContext, useContext, useState } from "react";

const VideoTutorialContext = createContext();

export const useVideoTutorial = () => {
  const context = useContext(VideoTutorialContext);
  if (!context) {
    throw new Error(
      "useVideoTutorial must be used within a VideoTutorialProvider"
    );
  }
  return context;
};

export const VideoTutorialProvider = ({ children }) => {
  const [showVideo, setShowVideo] = useState(false);

  const openVideo = () => {
    sessionStorage.removeItem("tutorialVideoClosed");
    setShowVideo(true);
  };

  const closeVideo = () => {
    sessionStorage.setItem("tutorialVideoClosed", "true");
    setShowVideo(false);
  };

  return (
    <VideoTutorialContext.Provider value={{ showVideo, openVideo, closeVideo }}>
      {children}
    </VideoTutorialContext.Provider>
  );
};
